import type { IconLibrary } from '../library';

const library: IconLibrary = {
  name: 'fa',
  resolver: name => {
    const filename = name.replace(/^fa[rbs]-/, '');
    const folderMap: { [key: string]: string } = {
      'fas-': 'solid',
      'fab-': 'brands',
      'far-': 'regular',
    };
    const prefix = name.substring(0, 4) as keyof typeof folderMap;
    const folder = folderMap[prefix] || 'regular';
    return `https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@5.15.1/svgs/${folder}/${filename}.svg`;
  },
  mutator: svg => svg.setAttribute('fill', 'currentColor'),
};

export default library;
